import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import BcMask from '@/components/Mask.vue';
import * as dd from 'dingtalk-jsapi';
// @ts-ignore
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
import BcDialog, { CBcDialog, CBcDialogForm } from '@/components/Dialog.vue';
import { Getter } from 'vuex-class';
import BcTable from '@/components/Table.vue';
// @ts-ignore
import jsQR from 'jsqr';
let OffineSync = class OffineSync extends Vue {
    constructor() {
        super(...arguments);
        this.snackbar = new CBcSnackbar();
        this.syncDlg = new CBcDialog(new CBcDialogForm());
        this.maskValue = {
            isShow: false
        };
        this.tableData = {
            desserts: []
        };
        // 配药记录表头
        this.recipelHeaders = [
            {
                text: '日期',
                align: 'center',
                value: 'date'
            },
            { text: '总条数', value: 'total', sortable: false },
            { text: '成功数', value: 'success', sortable: false },
            { text: '失败数', value: 'fails', sortable: false },
            { text: '总瓶数', value: 'bottles', sortable: false },
            { text: '使用时长', value: 'dspTime', sortable: false },
            { text: '同步状态', value: 'syncType', sortable: true }
        ];
        // 故障记录表头
        this.malfunctionHeaders = [
            {
                text: '日期',
                align: 'center',
                value: 'date'
            },
            { text: '故障内容', value: 'description', sortable: false },
            { text: '模块', value: 'module', sortable: false },
            { text: '故障编码', value: 'source', sortable: false },
            { text: '故障级别', value: 'level', sortable: false },
            { text: '同步状态', value: 'syncType', sortable: true },
            { text: '同步时间', value: 'syncTime', sortable: false },
        ];
        // 本次缓存设备id的同步情况 一次只处理一台设备
        this.localSync = {
            loading: false,
            deviceId: 0,
            deviceName: '',
            hospitalName: '',
            deviceNo: '',
            total: 0,
            syncTotal: 0,
            scanBarcode: [],
            syncItems: [],
            isComplete: false,
            barNum: 0,
            forceToggle: false,
            tabModel: '',
            deviceMode: '',
            actualScanCount: 0,
            lastSelectedFile: null // 记录上次选择的文件信息
        };
        // 图片放大相关
        this.showBigImg = false; // 是否显示放大图片弹窗
        this.currentIndex = 0; // 当前显示的图片索引
        this.selectedItem = 0;
        this.scanData = {}; // 扫码内容
        this.barcodeDlg = {
            visible: false
        };
        this.currentSyncTab = 'tab-recipel'; // 当前同步类型tab，默认为配药记录
    }
    // 计算属性：根据当前tab返回对应的表头
    get currentHeaders() {
        return this.currentSyncTab === 'tab-malfunction' ? this.malfunctionHeaders : this.recipelHeaders;
    }
    created() {
        console.log('OffineSync created', /^undefined$|^null$|^\s?$/i.test(this.userInfo.name) ? this.userInfo.userName : this.userInfo.name);
    }
    // 监听tab切换
    onCurrentSyncTabChange() {
        // 清空表格数据
        this.tableData.desserts = [];
        // 如果有正在进行的同步，提示用户
        if (this.localSync.deviceId > 0 && this.localSync.scanBarcode.length > 0) {
            this.snackbar.info('切换同步类型，当前同步数据已清空');
            // 重置同步状态
            this.localSync = {
                loading: false,
                deviceId: 0,
                deviceName: '',
                hospitalName: '',
                deviceNo: '',
                total: 0,
                syncTotal: 0,
                scanBarcode: [],
                syncItems: [],
                isComplete: false,
                barNum: 0,
                forceToggle: false,
                tabModel: '',
                deviceMode: '',
                actualScanCount: 0,
                lastSelectedFile: null
            };
        }
    }
    /**
     * 扫码
     */
    async scanBarcode() {
        const that = this;
        try {
            console.log('开始扫码，检测钉钉环境...');
            // 更全面的钉钉环境检测
            if (typeof window === 'undefined') {
                console.error('钉钉环境检测失败：window 对象不存在');
                that.snackbar.error('当前环境不支持扫码功能，请在钉钉应用中使用');
                return;
            }
            // 检查是否加载了钉钉SDK
            if (typeof dd === 'undefined') {
                console.error('钉钉环境检测失败：钉钉SDK未加载');
                that.snackbar.error('钉钉SDK未加载，请刷新页面重试或在钉钉应用中使用');
                return;
            }
            // 检查钉钉API是否可用
            if (!dd.biz || !dd.biz.util || !dd.biz.util.scan) {
                console.error('钉钉环境检测失败：扫码API不可用');
                that.snackbar.error('钉钉扫码API不可用，请确保在钉钉应用中使用');
                return;
            }
            // 检查是否在钉钉容器中
            const userAgent = navigator.userAgent || '';
            const isDingTalkApp = userAgent.includes('DingTalk') || userAgent.includes('dingtalk');
            if (!isDingTalkApp) {
                console.warn('用户代理检测：可能不在钉钉应用中', userAgent);
                // 不直接返回，因为有些情况下钉钉内嵌页面的userAgent可能不包含DingTalk标识
            }
            console.log('钉钉环境检测通过，开始调用扫码API...');
            if (dd) {
                if (dd.biz) {
                    if (dd.biz.util) {
                        if (/fun/i.test(typeof dd.biz.util.scan))
                            console.log('钉钉扫码API调用成功！');
                        else
                            console.log('钉钉扫码API调用失败！');
                    }
                    else
                        console.log('钉钉环境检测通过1，但钉钉扫码API调用失败！');
                }
                else
                    console.log('钉钉环境检测通过2，但钉钉扫码API调用失败！');
            }
            else
                console.log('钉钉环境检测通过3，但钉钉扫码API调用失败！');
            dd.biz.util.scan({
                type: 'all',
                onSuccess: async function (data) {
                    //onSuccess将在扫码成功之后回调
                    /* data结构
                      { 'text': String}
                    */
                    if (!data.text) {
                        that.snackbar.info('二维码无效，请检查');
                        return;
                    }
                    try {
                        that.scanData = JSON.parse(data.text);
                        // 检查节点
                        if (!that.scanData.records) {
                            that.snackbar.error('二维码内容错误，没有同步记录');
                            return;
                        }
                        // 来源为01时为博为的其他程序，这时需要单独处理
                        if (that.scanData.source == "01") {
                            if (!that.scanData.deviceNo) {
                                that.snackbar.error('二维码内容错误，设备编号不能为空');
                                return;
                            }
                            if (!that.scanData.deviceMode) {
                                that.snackbar.error('二维码内容错误，设备型号不能为空');
                                return;
                            }
                            // 获取设备id
                            const res = await that.axios.get(`/api/device?deviceId=${that.scanData.deviceNo}&mode=${that.scanData.deviceMode}`);
                            const list = res && res.data && res.data.result || [];
                            if (list.length == 0) {
                                that.snackbar.error('设备信息不存在，请检查！');
                                return;
                            }
                            if (list.length > 1) {
                                that.snackbar.error('存在多条设备信息，请检查！');
                                return;
                            }
                            that.scanData.deviceId = list[0].id;
                        }
                        if (!that.scanData.deviceId) {
                            that.snackbar.error('二维码内容错误，设备id不存在');
                            return;
                        }
                        if (!that.scanData.total) {
                            that.snackbar.error('二维码内容错误，总条数不存在');
                            return;
                        }
                        if (!that.scanData.barNum) {
                            that.snackbar.error('二维码内容错误，条码个数不存在');
                            return;
                        }
                        if (!that.scanData.currentBar) {
                            that.snackbar.error('二维码内容错误，当前条码编号不存在');
                            return;
                        }
                        if (that.localSync.deviceId !== that.scanData.deviceId) {
                            if (that.localSync.deviceId > 0 && !that.localSync.forceToggle) {
                                // 弹框提醒是否切换同步设备
                                that.showDialog('add');
                                return;
                            }
                        }
                        // 延迟一会儿打开
                        setTimeout(() => {
                            that.barcodeHandle(that.scanData);
                        }, 100);
                    }
                    catch (e) {
                        that.snackbar.error('二维码内容解析错误，请联系管理员');
                        return;
                    }
                },
                onFail: function (err) {
                    console.error('钉钉扫码onFail回调：', err);
                    const errorMsg = err && err.message ? err.message : err && err.toString ? err.toString() : JSON.stringify(err);
                    if (errorMsg.includes('notInDingTalk') || errorMsg.includes('Do not support the current environment')) {
                        that.snackbar.error('当前环境不支持扫码功能，请在钉钉应用中使用');
                    }
                    else if (errorMsg.includes('用户取消') || errorMsg.includes('cancel')) {
                        that.snackbar.info('用户取消扫码');
                    }
                    else {
                        that.snackbar.error('扫码失败：' + errorMsg);
                    }
                }
            });
        }
        catch (e) {
            // 捕获钉钉环境相关错误
            const errorMessage = e && e.message ? e.message : e && e.toString ? e.toString() : '未知错误';
            console.error('扫码错误详情：', e);
            if (errorMessage.includes('notInDingTalk') ||
                errorMessage.includes('Do not support the current environment') ||
                errorMessage.includes('not in dingtalk') ||
                errorMessage.includes('不在钉钉环境')) {
                that.snackbar.error('当前环境不支持扫码功能，请在钉钉应用中使用');
            }
            else if (errorMessage.includes('用户取消') || errorMessage.includes('cancel')) {
                that.snackbar.info('用户取消扫码');
            }
            else {
                that.snackbar.error('扫码功能异常：' + errorMessage);
            }
        }
        // 扫码扫出的数据 每次同步十条，records 记录明细，deviceId设备id，total总条数，barNum二维码总数，currentBar当前二维码下标
        // that.scanData = { "records": "o/Gh...zQw==", "deviceNo": "100001", "deviceId": "182", "total": 15, "barNum": 2, "currentBar": 2 }
        // that.scanData = {
        //     "deviceNo": "rtdc01003",
        //     "records": "eNqd0....XLO",
        //     "deviceMode": "BC-RTDC-01",
        //     "total": 24,
        //     "barNum": 1,
        //     "currentBar": 1,
        //     "source": "01"
        // };
        // // 来源为01时为博为的其他程序，这时需要单独处理
        // if (that.scanData.source == "01") {
        //     // 获取设备id
        //     const res: any = await that.axios.get(`/api/device?deviceId=${that.scanData.deviceNo}&mode=${that.scanData.deviceMode}`);
        //     const list = res && res.data && res.data.result || [];
        //     if (list.length == 0) {
        //         that.snackbar.error('设备信息不存在，请检查！');
        //         return;
        //     }
        //     if (list.length > 1) {
        //         that.snackbar.error('存在多条设备信息，请检查！');
        //         return;
        //     }
        //     that.scanData.deviceId = list[0].id
        // }
        // that.barcodeHandle(that.scanData);
        // if (that.localSync.deviceId !== that.scanData.deviceId) {
        //   if (that.localSync.deviceId > 0 && !that.localSync.forceToggle) {
        //     // 弹框提醒是否切换同步设备
        //     that.showDialog('add')
        //     return;
        //   }
        // }
    }
    /**
     * 图片上传
     */
    uploadImage() {
        this.$refs.imageInput.click();
    }
    /**
      * 处理图片上传
      */
    handleImageUpload(event) {
        const target = event.target;
        const file = target.files?.[0];
        if (!file) {
            return;
        }
        // 检查是否选择了相同的文件
        if (this.localSync.lastSelectedFile &&
            this.localSync.lastSelectedFile.name === file.name &&
            this.localSync.lastSelectedFile.size === file.size &&
            this.localSync.lastSelectedFile.lastModified === file.lastModified) {
            this.snackbar.info('您选择了相同的图片，将重新处理');
        }
        // 检查文件类型
        if (!file.type.startsWith('image/')) {
            this.snackbar.error('请选择图片文件');
            return;
        }
        // 检查文件大小 (限制为10MB)
        if (file.size > 10 * 1024 * 1024) {
            this.snackbar.error('图片文件大小不能超过10MB');
            return;
        }
        // 记录当前选择的文件信息
        this.localSync.lastSelectedFile = {
            name: file.name,
            size: file.size,
            lastModified: file.lastModified
        };
        this.processImageForQR(file);
    }
    /**
      * 处理图片二维码识别
      */
    processImageForQR(file) {
        const that = this;
        const reader = new FileReader();
        reader.onload = (e) => {
            const img = new Image();
            img.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                if (!ctx) {
                    that.snackbar.error('无法创建画布');
                    return;
                }
                canvas.width = img.width;
                canvas.height = img.height;
                ctx.drawImage(img, 0, 0);
                const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                // 改进：使用多策略识别，提高拍照图片识别率
                const code = jsQR(imageData.data, imageData.width, imageData.height, {
                    inversionAttempts: 'attemptBoth' // 尝试正反两种颜色模式
                });
                if (code) {
                    console.log('图片识别二维码成功：');
                    that.processQRData(code.data);
                }
                else {
                    console.log('error 未能识别二维码，尝试多尺度扫描...');
                    // 如果基础识别失败，尝试多尺度扫描
                    this.attemptMultiScaleRecognition(ctx, canvas, that);
                }
            };
            img.src = e.target?.result;
        };
        reader.readAsDataURL(file);
    }
    /**
       * 多尺度扫描二维码识别（用于提高拍照图片识别率）
       * @param ctx Canvas 上下文
       * @param canvas Canvas 元素
       * @param that 当前组件实例
       */
    attemptMultiScaleRecognition(ctx, canvas, that) {
        const scales = [0.5, 0.75, 1.0, 1.25, 1.5, 1.75, 2.0];
        for (let scale of scales) {
            const scaledWidth = Math.floor(canvas.width * scale);
            const scaledHeight = Math.floor(canvas.height * scale);
            const tempCanvas = document.createElement('canvas');
            const tempCtx = tempCanvas.getContext('2d');
            if (!tempCtx)
                continue;
            tempCanvas.width = scaledWidth;
            tempCanvas.height = scaledHeight;
            tempCtx.drawImage(canvas, 0, 0, scaledWidth, scaledHeight);
            const scaledData = tempCtx.getImageData(0, 0, scaledWidth, scaledHeight);
            const code = jsQR(scaledData.data, scaledWidth, scaledHeight, {
                inversionAttempts: 'attemptBoth'
            });
            if (code) {
                console.log(`多尺度识别成功（比例：${scale}）:`, code.data);
                that.processQRData(code.data);
                return;
            }
        }
        console.log('多尺度扫描也失败了');
        that.snackbar.error('未能识别到二维码，请确保图片清晰且包含有效的二维码');
    }
    /**
       * 处理二维码数据
       */
    async processQRData(qrText) {
        const that = this;
        if (!qrText) {
            that.snackbar.info('二维码无效，请检查');
            return;
        }
        try {
            that.scanData = JSON.parse(qrText);
            // 检查节点
            if (!that.scanData.records) {
                that.snackbar.error('二维码内容错误，没有同步记录');
                return;
            }
            // 来源为01时为博为的其他程序，这时需要单独处理
            if (that.scanData.source == "01") {
                if (!that.scanData.deviceNo) {
                    that.snackbar.error('二维码内容错误，设备编号不能为空');
                    return;
                }
                if (!that.scanData.deviceMode) {
                    that.snackbar.error('二维码内容错误，设备型号不能为空');
                    return;
                }
                // 获取设备id
                const res = await that.axios.get(`/api/device?deviceId=${that.scanData.deviceNo}&mode=${that.scanData.deviceMode}`);
                const list = res && res.data && res.data.result || [];
                if (list.length == 0) {
                    that.snackbar.error('设备信息不存在，请检查！');
                    return;
                }
                if (list.length > 1) {
                    that.snackbar.error('存在多条设备信息，请检查！');
                    return;
                }
                that.scanData.deviceId = list[0].id;
            }
            if (!that.scanData.deviceId) {
                that.snackbar.error('二维码内容错误，设备id不存在');
                return;
            }
            if (!that.scanData.total) {
                that.snackbar.error('二维码内容错误，总条数不存在');
                return;
            }
            if (!that.scanData.barNum) {
                that.snackbar.error('二维码内容错误，条码个数不存在');
                return;
            }
            if (!that.scanData.currentBar) {
                that.snackbar.error('二维码内容错误，当前条码编号不存在');
                return;
            }
            if (that.localSync.deviceId !== that.scanData.deviceId) {
                if (that.localSync.deviceId > 0 && !that.localSync.forceToggle) {
                    // 弹框提醒是否切换同步设备
                    that.showDialog('add');
                    return;
                }
            }
            // 延迟一会儿打开
            setTimeout(() => {
                that.barcodeHandle(that.scanData);
            }, 100);
        }
        catch (e) {
            that.snackbar.error('二维码内容解析错误，请联系管理员');
            return;
        }
    }
    /**
     * 二维码展示
     */
    async showBarcode() {
        // 倒序展示
        const that = this;
        if ((that.localSync.scanBarcode || []).length == 0) {
            that.snackbar.info('请先进行扫码上传');
            return;
        }
        that.barcodeDlg.visible = true;
    }
    // 处理扫描内容
    async barcodeHandle(data) {
        const that = this;
        that.localSync.loading = true;
        try {
            // 只有设备发生变化后在重新去获取设备信息
            if (that.localSync.deviceId == 0) {
                const res = await that.axios.get('/api/device?id=' + data.deviceId);
                const list = res && res.data && res.data.result || [];
                if (list.length == 0) {
                    that.snackbar.error('设备信息获取失败，设备id不存在，请检查');
                    that.localSync.loading = false;
                    return;
                }
                that.localSync.deviceName = list[0].name;
                that.localSync.hospitalName = list[0].hospitalName;
                that.localSync.deviceNo = data.deviceNo;
                that.localSync.deviceId = data.deviceId;
                that.localSync.deviceMode = list[0].mode;
            }
            that.localSync.total = data.total; // 总条数
            that.localSync.barNum = data.barNum; // 总条码个数
            // 检查二维码类型与当前选中tab是否匹配
            const qrCodeType = String(data.t).toLowerCase();
            const isErrorType = qrCodeType === 'e'; // 故障类型
            const isCurrentTabMalfunction = that.currentSyncTab === 'tab-malfunction';
            if (isErrorType && !isCurrentTabMalfunction) {
                that.localSync.loading = false;
                that.snackbar.error('当前扫描的是故障记录二维码，请切换到故障记录tab后再扫描');
                return;
            }
            if (!isErrorType && isCurrentTabMalfunction) {
                that.localSync.loading = false;
                that.snackbar.error('当前扫描的是配药记录二维码，请切换到配药记录tab后再扫描');
                return;
            }
            let apiUrl = '/api/device/sync/recipel'; // 默认使用原接口
            let postData = {
                type: String(data.t).toLowerCase() == 'e' ? 'error' : data.t,
                records: data.records,
                deviceNo: that.localSync.deviceNo,
                deviceId: that.localSync.deviceId,
                isOffineSync: true,
                userId: that.userInfo.userId,
                recorder: /^undefined$|^null$|^\s?$/i.test(that.userInfo.name) ? that.userInfo.userName : that.userInfo.name,
                deviceMode: that.localSync.deviceMode
            };
            // 根据当前选择的tab类型和数据类型选择不同的接口和参数
            if (that.currentSyncTab === 'tab-malfunction' || data.syncType === 'error') {
                // 故障记录同步，使用专用的malfunction接口
                apiUrl = '/api/device/sync/malfunction';
                postData.syncType = 'error';
            }
            else if (data.source == "01") {
                // 当博为其他项目做数据同步时
                apiUrl = '/api/device/sync/records';
            }
            else {
                // 配药记录同步，使用默认的recipel接口
                postData.syncType = 'recipel';
            }
            // 提交到后端保存同步上传数据
            await that.axios.post(apiUrl, postData, {
                headers: {
                    'bc-user-agent': 'bcMachineSync'
                }
            }).then(async (res) => {
                const resData = res.data;
                // 处理新的syncResults数据结构
                let syncResults = resData.syncResults || [];
                let success = [];
                let fails = [];
                if (syncResults.length > 0) {
                    syncResults.forEach((result) => {
                        // 根据success字段判断成功或失败
                        if (result.success) {
                            result.syncType = 1; // 1-上传成功
                            // 构造前端需要的数据格式
                            const successItem = {
                                ...(result || {}),
                                id: result.id,
                                date: result.date || result.syncTime,
                                description: result.description || '故障记录',
                                deviceStateCode: result.code,
                                level: result.level || '',
                                module: result.module || '',
                                syncType: 1
                            };
                            success.push(successItem);
                        }
                        else {
                            result.syncType = 0; // 0-失败
                            // 构造前端需要的数据格式
                            const failItem = {
                                ...(result || {}),
                                id: result.id,
                                date: result.date || result.syncTime,
                                description: result.description || '故障记录',
                                deviceStateCode: result.code,
                                level: result.level || '',
                                module: result.module || '',
                                syncType: 0
                            };
                            fails.push(failItem);
                        }
                    });
                }
                else {
                    // 兼容旧的数据结构
                    success = (resData.success || []).filter((v) => /object/i.test(typeof v));
                    if (success.length > 0) {
                        success.forEach((o) => {
                            o['syncType'] = 1; // 1-上传成功
                        });
                    }
                    fails = (resData.fails || []).filter((v) => /object/i.test(typeof v));
                    if (fails.length > 0) {
                        fails.forEach((o) => {
                            o['syncType'] = 0; // 1-上传成功 0-失败
                        });
                    }
                }
                // 处理exists数据，确保重复扫码时也能显示对应的条目
                let exists = (resData.exists || []).filter((v) => /object/i.test(typeof v));
                // 这里会有顺序，先出现失败就已失败为准，去重时会以前面的元素为准
                let list = [...fails, ...success, ...exists, ...that.tableData.desserts].filter((item, index, self) => index === self.findIndex(obj => obj.date === item.date));
                // 检查是否为相同条码的重复扫描
                var barcode = that.localSync.scanBarcode.find((o) => o.barcode == data.currentBar);
                let isRepeatScan = !!barcode;
                if (!barcode) {
                    // 新条码，添加到扫码记录
                    that.localSync.scanBarcode.push({
                        barcode: data.currentBar,
                        encData: resData.encData || ''
                    });
                }
                else {
                    // 重复扫码，更新encData
                    barcode.encData = resData.encData || '';
                }
                // 处理exists数据，确保显示在表格中
                if (exists.length > 0) {
                    exists.forEach((item) => {
                        // 为exists数据设置syncType为2（已存在状态）
                        item.syncType = 2;
                    });
                }
                if ((!list || list.length == 0) && (!exists || exists.length == 0)) {
                    // 检查接口返回的成功状态
                    if (resData.successState === true) {
                        that.snackbar.success(resData.message || '同步成功');
                    }
                    else if (resData.allExists) {
                        that.snackbar.success(resData.message || '所有数据已存在，无需重复同步');
                    }
                    else {
                        that.snackbar.error('离线同步失败，暂未同步数据，请检查');
                    }
                    that.localSync.loading = false;
                    return;
                }
                // 使用Map来避免重复计数相同批次的数据
                const existingDatesMap = new Map();
                that.tableData.desserts.forEach((item) => {
                    existingDatesMap.set(item.date, item);
                });
                // 降序排序
                list.sort((a, b) => Date.parse(b.date) - Date.parse(a.date));
                list.forEach((item) => {
                    if (!existingDatesMap.has(item.date)) {
                        existingDatesMap.set(item.date, {
                            ...item,
                            id: item.id,
                            date: item.date,
                            description: item.description,
                            module: item.module,
                            syncTime: item.syncTime,
                            total: item.total,
                            success: item.success,
                            fails: item.fails,
                            bottles: item.bottles,
                            dspTime: item.dspTime,
                            syncType: item.syncType || 1 // 新同步的数据默认为成功状态
                        });
                    }
                });
                // 重新构建desserts数组并排序
                that.tableData.desserts = Array.from(existingDatesMap.values());
                that.tableData.desserts.sort((a, b) => Date.parse(b.date) - Date.parse(a.date));
                let recordType = that.currentSyncTab === 'tab-malfunction' ? '故障记录' : '配药记录';
                let message = "";
                if (!isRepeatScan) {
                    message += `扫码成功，${recordType}已添加`;
                    // 更新实际扫描记录数量
                    that.localSync.actualScanCount = that.localSync.scanBarcode.length;
                }
                else {
                    message += `重复扫码，${recordType}已更新`;
                    // 重复扫码时，actualScanCount保持不变，不增加计数
                    console.log('重复扫码------：', data.currentBar);
                }
                if (that.localSync.scanBarcode.length == that.localSync.barNum) {
                    message += "，所有条码已扫描完成";
                }
                that.snackbar.success(message);
                // 弹出完成同步的二维码
                that.localSync.loading = false;
                if (resData.encData) {
                    // 携带设备id和条码号
                    const text = JSON.stringify({ c: resData.encData, d: that.localSync.deviceId, s: data.currentBar });
                    // 生成二维码图片
                    const qrcodeRaw = await that.axios.post('/api/device/licenses/qrcode', { text: text }, { responseType: 'blob' });
                    const reader = new FileReader();
                    reader.readAsDataURL(qrcodeRaw.data);
                    reader.onload = () => {
                        const currentBarcode = that.localSync.scanBarcode.find((o) => o.barcode == data.currentBar);
                        if (currentBarcode) {
                            currentBarcode.imgUrl = reader.result;
                            that.localSync.tabModel = `tab-${currentBarcode.barcode}`;
                            that.$nextTick(() => {
                                setTimeout(() => {
                                    that.showBarcode(); // 弹出同步回执
                                }, 50);
                            });
                        }
                    };
                }
            }).catch((e) => {
                that.localSync.loading = false;
                that.snackbar.error('离线同步失败，' + (e && (e.info || e.error || e.result))) + '，请检查后重试';
                console.log(e);
            });
        }
        catch (e) {
            that.localSync.loading = false;
            that.snackbar.error('离线参数处理失败，请联系管理员。');
            console.log(e);
        }
    }
    showDialog(type) {
        const that = this;
        that.syncDlg.type = type;
        that.syncDlg.title = '提示';
        that.syncDlg.visible = true;
    }
    dialogSave() {
        const that = this;
        if (that.syncDlg.isEditType) {
            // 二维码展示时不做操作
            return;
        }
        that.localSync.forceToggle = true; // 强制切换
        // 恢复默认值
        that.localSync = {
            deviceId: 0,
            deviceName: '',
            hospitalName: '',
            deviceNo: '',
            total: 0,
            syncTotal: 0,
            scanBarcode: [],
            syncItems: [],
            isComplete: false,
            barNum: 0,
            forceToggle: false,
            loading: false,
            tabModel: '',
            actualScanCount: 0
        };
        that.barcodeHandle(that.scanData);
    }
    // 倒序输出
    reversedArray() {
        const that = this;
        if ((that.localSync.scanBarcode || []).length === 0) {
            return [];
        }
        return that.localSync.scanBarcode.slice();
    }
    // 打开图片放大弹窗
    openImageDialog(index) {
        const reversedIndex = this.reversedArray().length - 1 - index;
        this.currentIndex = reversedIndex;
        this.showBigImg = true;
    }
    // 切换图片
    toggleImage(direction) {
        const newIndex = this.currentIndex + direction;
        const maxIndex = this.reversedArray().length - 1;
        if (newIndex >= 0 && newIndex <= maxIndex) {
            this.currentIndex = newIndex;
        }
    }
};
__decorate([
    Getter
], OffineSync.prototype, "userInfo", void 0);
__decorate([
    Watch('currentSyncTab')
], OffineSync.prototype, "onCurrentSyncTabChange", null);
OffineSync = __decorate([
    Component({
        name: 'OffineSync',
        components: {
            BcMask,
            BcSnackbar,
            BcDialog,
            BcTable
        },
        filters: {
            dateFormat(date) {
                if (!date)
                    return '';
                const dates = new Date(date);
                return dates.format('yyyy-MM-dd');
            }
        }
    })
], OffineSync);
export default OffineSync;
